import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

const GameCardSkeleton = () => (
  <section className="w-full px-5 justify-between mb-[19px] text-[#212121] items-start">
    <div className="flex mb-8 landscape:mb-4 gap-[10px]">
      <Skeleton className="w-[40px] h-[40px] rounded-full" />

      <div className="flex flex-col justify-between w-full leading-none gap-1.5">
        <div className="flex items-end justify-between w-full">
          <Skeleton className="h-[22px] w-[120px]" />
          <Skeleton className="h-[20px] w-[60px]" />
        </div>
        <div className="flex items-end text-[14px] justify-between w-full h-full">
          <Skeleton className="h-[20px] w-[80px]" />
          <Skeleton className="h-[20px] w-[40px]" />
        </div>
        <div className="flex items-center text-[18px] justify-between w-full h-full font-medium landscape:hidden">
          <Skeleton className="h-[22px] w-[50px]" />
          <Skeleton className="h-[22px] w-[60px]" />
        </div>
      </div>
    </div>
    <div className="flex items-center text-[18px] justify-between w-full h-full font-medium portrait:hidden">
      <Skeleton className="h-[22px] w-[50px]" />
      <Skeleton className="h-[22px] w-[60px]" />
    </div>
  </section>
);

export default React.memo(GameCardSkeleton);
